export default {"src":"/_next/static/media/View.4e0d1ccc.svg","height":20,"width":20};